import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { SimulationHeader } from '../../models/simulation';

@Component({
    selector: 'simulation-header',
    templateUrl: './header.component.html',
    styleUrls: ['../job-simulator/job-simulator.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Output() onNewVersion = new EventEmitter<void>();

  header: SimulationHeader = {};
  consumerCompanies: SelectItem[] = [];

  constructor() { }

  ngOnInit() {
  }

  /* Send an event to request a new version */
  requestNewVersion() {
    this.onNewVersion.emit();
  }
}
